import styled from 'styled-components';

const SectionHeader = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  margin: ${props => props.margin};
  min-height: ${props => props.lineHeight}px;
`;

SectionHeader.defaultProps = {
  margin: '0',
  lineHeight: 40
};

export const LeftSection = styled.section`
  position: relative;
`;
export const RightSection = styled.section`
  margin-left: auto;
`;

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/layouts/SectionHeader.js